import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import ReduxToastr from 'react-redux-toastr'
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import App from './components/App'
import store from './store'

const confirmOptions = {
    okText: 'OK',
    cancelText: 'Отмена'
}

ReactDOM.render(
    <Provider store={store}>
        <Fragment>
            <App />
            <ReduxToastr
                timeOut={4000}
                newestOnTop={false}
                preventDuplicates
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                confirmOptions={confirmOptions}
            />
        </Fragment>
    </Provider>,
    document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js